import React, { useState } from 'react';
import { IconButton, InputBase } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import './retail.scss';

interface RetailPOSSearchBarProps {
	value?: string;
	onChangeAction?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onCloseAction?: () => void;
	placeholder?: any;
}

export const RetailPOSSearchBar: React.FC<RetailPOSSearchBarProps> = ({
	value,
	onChangeAction,
	onCloseAction,
	placeholder = 'Search here..',
}) => {
	const [inputValue, setInputValue] = useState(value || '');

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setInputValue(event.target.value);
		if (onChangeAction) {
			onChangeAction(event);
		}
	};

	const handleClose = () => {
		setInputValue('');
		if (onCloseAction) {
			onCloseAction();
		}
		// Trigger onChange with empty value
		if (onChangeAction) {
			const event = {
				target: { value: '' },
			} as React.ChangeEvent<HTMLInputElement>;
			onChangeAction(event);
		}
	};

	return (
		<div className="retail-pos-search-bar">
			<InputBase
				className="retail-pos-search-input"
				placeholder={placeholder}
				value={inputValue}
				onChange={handleChange}
				fullWidth
			/>
			{inputValue && (
				<IconButton
					className="retail-pos-search-close"
					onClick={handleClose}
					aria-label="clear search"
					size="small"
				>
					<Close />
				</IconButton>
			)}
		</div>
	);
};

export default RetailPOSSearchBar;
